import React, {FC} from "react";
import {StyledDiv, StyledTypography} from "../../providers/layout/LayoutProvider";
import {makeStyles} from "@mui/styles";
import {useConsumerSendMailMutation} from "../../Queries";
import {isValidEmail} from "../../components/Validations";
import clsx from "clsx";
import {Theme} from "@mui/material";
import {useRecoilValue} from "recoil";
import {DropOffIcon, PackItIcon, TradeInIcon} from "../../svg/SvgIcons";
import {LocalizationsAtom} from "../../providers/localization/LocalizationProvider";

export const MoonboonPage: FC<any> = () => {
   const localizations = useRecoilValue(LocalizationsAtom);
   const classes = useStyles({
      leftImage: "url('" + (localizations.frontPageImage1 || "https://cdn.shopify.com/s/files/1/0499/3348/4195/files/cradle-essential-bundle-lifestyle01_c0d03513-13d4-4e04-98ba-7284585a094b.jpg?v=1730444996") + "')",
      rightImage: "url('" + (localizations.frontPageImage2 || "https://cdn.shopify.com/s/files/1/0499/3348/4195/files/bloggis_23.png?v=1728041066") + "')"
   });

   return <div>
      <StyledDiv type={"main"} className={classes.container}>
         <StyledDiv type={"main"} className={clsx(classes.image, classes.leftImage)}>
            &nbsp;
         </StyledDiv>
         <StyledDiv type={"contrast"} className={classes.main}>
            <div className={classes.content}>
               <StyledTypography variant={"h1"} type={"main"} style={{marginBottom: '26px'}}>
                  {localizations.loginPageTitle}
               </StyledTypography>
               <StyledTypography variant={"body1"} type={"main"} style={{marginBottom: '20px'}}>
                  {localizations.loginPageDescription}<br/>
                  {localizations.loginPageDescription2}
               </StyledTypography>
               <div className={classes.accessForm}>
                  <AccessForm/>
               </div>
            </div>
         </StyledDiv>
         <StyledDiv type={"main"} className={clsx(classes.image, classes.rightImage)}>
            &nbsp;
         </StyledDiv>
      </StyledDiv>
      <MoonboonEasyBox/>
   </div>
}

type imageProps = {
   leftImage: string
   rightImage: string
}

const useStyles = makeStyles({
   backContainer: {
      marginTop: '20px'
   },
   content: {
      maxWidth: '500px',
      textAlign: 'center'
   },
   container: {
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      alignItems: 'top',
      padding: '0 40px 0 40px'
   },
   accessForm: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
   },
   image: {
      width: '400px',
      minHeight: '496px',
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "top center",
      overflowX: 'hidden',
      overflowY: 'hidden',
   },
   main: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      flexGrow: 1,
      padding: '50px'
   },
   leftImage: {
      backgroundImage: (props: imageProps) => props.leftImage
   },
   rightImage: {
      backgroundImage: (props: imageProps) => props.rightImage
   },
   '@media only screen and (max-width: 800px)': {
      container: {
         flexDirection: 'column',
         padding: '0 23px 0 23px'
      } as any,
      image: {
         width: '100%',
         maxHeight: '200px',
         minHeight: '300px',
         backgroundPosition: "center",
      }
   },
   '@media only screen and (max-width: 1024px)': {
      container: {
         padding: '0 23px 0 23px'
      } as any
   },
})

export const AccessForm = () => {
   const localizations = useRecoilValue(LocalizationsAtom);
   const [email, setEmail] = React.useState<string>('');
   const [sent, setSent] = React.useState<boolean>(false);

   const classes = useAccessFormStyles();

   const [sendMail] = useConsumerSendMailMutation();

   const onChange = (event: any) => {
      setEmail(event.target.value);
      setSent(false);
   }

   const onSend = async () => {
      let shopId = window.shopId || window.brandId;
      if (!!email && isValidEmail(email)) {
         await sendMail({
            variables: {
               shopId: shopId,
               mail: email
            }
         });
         setEmail('');
         setSent(true);
      }
   }

   return <>
      <form className={classes.lightBoxInputArea} onSubmit={async (e) => {
         e.preventDefault();
         await onSend();
      }}>
         <div className="tw-flex">
            <div className="klaviyo_form_actions tw-w-full">
               <input
                  value={email}
                  placeholder={localizations.mainPageEnterEmail}
                  required={true}
                  onChange={onChange}
                  className="!tw-h-[40px] !tw-bg-white tw-w-full !tw-border-none tw-pl-[15px] !tw-text-[13px] !tw-placeholder-black !tw-mb-0"
                  type="email" name="email" id="email" />
            </div>
            <div className="klaviyo_form_actions">
               <button type="submit"
                       className="tw-flex tw-items-center tw-justify-center tw-bg-[#b59e85] js-submit-klaviyo tw-w-10 tw-h-10"
                       aria-label={localizations.mainPageEnterEmail}>

                  <svg enable-background="0 0 32 32" height="32px" version="1.1" viewBox="0 0 32 32" width="32px"
                       xmlSpace="preserve" xmlns="http://www.w3.org/2000/svg"
                       xmlnsXlink="http://www.w3.org/1999/xlink">
                     <path clip-rule="evenodd" d="M21.698,15.286l-9.002-8.999  c-0.395-0.394-1.035-0.394-1.431,0c-0.395,0.394-0.395,1.034,0,1.428L19.553,16l-8.287,8.285c-0.395,0.394-0.395,1.034,0,1.429  c0.395,0.394,1.036,0.394,1.431,0l9.002-8.999C22.088,16.325,22.088,15.675,21.698,15.286z" fill="#121313" fill-rule="evenodd" id="Chevron_Right"></path>
                     <g></g>
                     <g></g>
                     <g></g>
                     <g></g>
                     <g></g>
                     <g></g></svg>

               </button>
            </div>
         </div>
      </form>
      {sent && <div className={classes.emailSent}>
         <StyledTypography variant={"body1"} className={classes.emailSentDivider}
                           type={"main"}>{localizations.mainPageMailSent}</StyledTypography>
         <StyledTypography variant={"body1"} type={"main"}>{localizations.mainPageMailSent2}</StyledTypography>
      </div>}
   </>
}

const useAccessFormStyles = makeStyles({
   input: {
      width: '100%',
      height: '45px',
      borderRadius: '20px',
      minWidth: '300px'
   },
   button: {
      height: '45px'
   },
   lightBoxInputArea: {
      display: 'flex',
      alignItems: 'center'
   },
   lightBoxMaxWidth: {
      maxWidth: '60%',
      margin: '0 auto'
   },
   emailSent: {
      marginTop: '20px',
      textAlign: 'center',
      padding: '20px'
   },
   emailSentDivider: {
      marginBottom: '15px'
   },
});


const MoonboonEasyBox = () => {
   const localizations = useRecoilValue(LocalizationsAtom);
   const classes = useEasyStyles();
   return <div className={classes.container}>
      <div>
         <StyledTypography variant={"h1"} className={classes.title}>
            {localizations.easyBoxTitle}
         </StyledTypography>
      </div>
      <div>
         <div className={classes.list}>
            <div className={classes.listItem}>
               <div className={classes.listAvatar}>
                  <TradeInIcon type={"contrast"}/>
               </div>
               <div className={classes.listText}>
                  <StyledTypography variant={"h2"} className={classes.text}>
                     {localizations.easyBoxSection1Title}
                  </StyledTypography>
                  <StyledTypography variant={"body1"}>
                     {localizations.easyBoxSection1Description}
                  </StyledTypography>
               </div>
            </div>
            <div className={classes.listItem}>
               <div className={classes.listAvatar}>
                  <PackItIcon type={"contrast"}/>
               </div>
               <div className={classes.listText}>
                  <StyledTypography variant={"h2"} className={classes.text}>
                     {localizations.easyBoxSection2Title}
                  </StyledTypography>
                  <StyledTypography variant={"body1"}>
                     {localizations.easyBoxSection2Description}
                  </StyledTypography>
               </div>
            </div>
            <div className={classes.listItem}>
               <div className={classes.listAvatar}>
                  <DropOffIcon type={"contrast"}/>
               </div>
               <div className={classes.listText}>
                  <StyledTypography variant={"h2"} className={classes.text}>
                     {localizations.easyBoxSection3Title}
                  </StyledTypography>
                  <StyledTypography variant={"body1"}>
                     {localizations.easyBoxSection3Description}
                  </StyledTypography>
               </div>
            </div>
         </div>
      </div>
   </div>
}


const useEasyStyles = makeStyles((theme: Theme) => ({
      container: {
         display: 'flex',
         flexDirection: 'column',
         alignItems: 'center'
      },
      title: {
         marginTop: '40px'
      },
      text: {
         marginBottom: '15px'
      },
      list: {
         display: 'flex',
         flexDirection: 'row',
         justifyContent: 'center',
         marginTop: '40px'
      },
      listItem: {
         display: 'flex',
         flexDirection: 'column',
         alignItems: 'center',
         marginBottom: '20px',
         gap: '10px'
      },
      listAvatar: {},
      listText: {
         marginTop: '0',
         textAlign: 'center',
         maxWidth: '400px',
         padding: '0 20px 0 20px'
      },
      '@media only screen and (max-width: 800px)': {
         list: {
            flexDirection: 'column',
         },
         listItem: {
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            maxWidth: '600px',
            gap: '10px'
         },
      }
   }),
);
